import {TimePicker} from "antd";
import React, {useEffect, useState} from "react";
import moment from "moment";

export default function TimePickerForm(props: any) {
    const [value, setValue]: any = useState(moment());

    useEffect(() => {
        setValue(moment(props.value));
    }, [props.value])

    return <TimePicker value={value} defaultValue={value} onChange={(value1, dateString) => {
        props.onChange(value1?.toDate().getTime());
    }} format="HH:mm"/>
}
